import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { styled } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import { CircularProgress } from "@mui/material";

const CustomAlert = styled(Alert)({
    fontFamily: "Inter",
});

export default function ContactForm() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [sending, setSending] = useState(false);

    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);

    const handleCloseAlert = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setShowSuccessAlert(false);
        setShowErrorAlert(false);
    };

    const form = useRef();

    const clearFields = () => {
        setName("");
        setEmail("");
        setPhoneNo("");
        setSubject("");
        setMessage("");
    };

    const sendEmail = (e) => {
        e.preventDefault();

        const emailData = {
            from_name: name,
            from_email: email,
            from_phone_no: phoneNo,
            subject: subject,
            message: message,
        };

        const serviceKey = process.env.REACT_APP_EMAILJS_SERVICE_KEY;
        const templateKey = process.env.REACT_APP_EMAILJS_TEMPLATE_KEY;
        const userKey = process.env.REACT_APP_EMAILJS_USER_KEY;

        setSending(true);

        emailjs.send(serviceKey, templateKey, emailData, userKey).then(
            (result) => {
                setSending(false);
                setShowSuccessAlert(true);
                clearFields();
                console.log(result.text);
            },
            (error) => {
                setSending(false);
                setShowErrorAlert(true);
                console.log(error.text);
            }
        );
    };

    return (
        <form ref={form} onSubmit={sendEmail}>
            <div className="Contact-Field-Container">
                <label className="Contact-Form-Label">Name *</label>
                <input
                    className="input"
                    type="text"
                    placeholder="Your Name"
                    name="from_name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
            </div>
            <div className="Contact-Field-Container">
                <label className="Contact-Form-Label">Email Address *</label>
                <input
                    className="input"
                    type="email"
                    placeholder="name@example.com"
                    name="from_email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
            </div>
            <div className="Contact-Field-Container">
                <label className="Contact-Form-Label">Phone Number</label>
                <input
                    className="input"
                    type="tel"
                    placeholder="Phone Number"
                    name="from_phone_no"
                    value={phoneNo}
                    onChange={(e) => setPhoneNo(e.target.value)}
                />
            </div>
            <div className="Contact-Field-Container">
                <label className="Contact-Form-Label">Subject *</label>
                <input
                    className="input"
                    type="text"
                    placeholder="e.g. issue with Quickmoji"
                    name="subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    required
                />
            </div>
            <div className="Contact-Field-Container">
                <label className="Contact-Form-Label">Message *</label>
                <textarea
                    className="textarea"
                    type="text"
                    placeholder="Please explain how we can best help you"
                    name="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                />
            </div>
            <div className="Contact-Submit-Container">
                <div className="control">
                    <button className="button is-rounded Contact-Button">
                        Submit
                    </button>
                </div>
                {sending && <CircularProgress style={{ color: "#845EC2" }} />}
            </div>
            <div>
                <Snackbar
                    open={showSuccessAlert}
                    autoHideDuration={6000}
                    onClose={handleCloseAlert}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    TransitionComponent={Slide}
                >
                    <CustomAlert severity="success">
                        Email sent successfully!
                    </CustomAlert>
                </Snackbar>
            </div>
            <div>
                <Snackbar
                    open={showErrorAlert}
                    autoHideDuration={6000}
                    onClose={handleCloseAlert}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    TransitionComponent={Slide}
                >
                    <CustomAlert severity="error">
                        Something went wrong, please try again!
                    </CustomAlert>
                </Snackbar>
            </div>
        </form>
    );
}
